import { createI18n } from 'vue-i18n'
import CN from './zh-CN'
import EN from './en-US'
import DE from './de-DE'
import JP from "@/language/jp-JP";
export default createI18n({
    locale: 'zh-CN',
    legacy: true,
    allowComposition: true,
    fallbackLocale: 'en-US',
    messages: {
        'zh-CN': CN,
        'en-US': EN,
        'de-DE': DE,
        'jp-JP': JP
    }
})